import React from 'react'

export function CheckSvg() {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.62063 11.2076C4.64634 11.2393 4.67433 11.2698 4.70457 11.2989C5.10191 11.6813 5.73964 11.6747 6.12899 11.2842L15.2943 2.0917C15.6836 1.7012 15.6771 1.07467 15.2798 0.692305C14.8825 0.309939 14.2447 0.316534 13.8554 0.707035L5.40705 9.18044L2.09531 6.15502C1.69553 5.7898 1.08451 5.81709 0.717668 6.21656L0.689977 6.24671C0.310697 6.65972 0.337093 7.31138 0.748489 7.69121L4.37707 11.0414C4.45254 11.1111 4.53466 11.1662 4.62063 11.2076Z"
        fill="currentColor"
      />
    </svg>
  )
}
